export enum CheckTypeEnum {
    Scan = 'Scan',
    Form = 'Form',
}
